/**
 * BrewNectar Compare Deep Dives — accordion + fade-up
 */
(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initFadeUp(root) {
    var animated = root.querySelectorAll('.bn-cdd__animate');

    if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
      animated.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var rootMargin = root.getAttribute('data-bn-cdd-observer-margin') || '-60px 0px';
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { root: null, rootMargin: rootMargin, threshold: 0 }
    );

    animated.forEach(function (el) {
      observer.observe(el);
    });
  }

  function setItemOpen(item, open) {
    var trigger = item.querySelector('[data-bn-cdd-trigger]');
    var panel = item.querySelector('[data-bn-cdd-panel]');
    if (!trigger || !panel) return;

    item.classList.toggle('is-open', open);
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
  }

  function initAccordion(root) {
    var allowMultiple = root.getAttribute('data-bn-cdd-allow-multiple') === 'true';
    var items = root.querySelectorAll('[data-bn-cdd-item]');
    var triggers = root.querySelectorAll('[data-bn-cdd-trigger]');

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-bn-cdd-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        if (!allowMultiple) {
          items.forEach(function (other) {
            if (other !== item) setItemOpen(other, false);
          });
        }

        setItemOpen(item, !isOpen);
      });
    });

    root.addEventListener('keydown', function (e) {
      var triggerList = Array.prototype.slice.call(triggers);
      var index = triggerList.indexOf(document.activeElement);
      if (index === -1) return;

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        var next = triggerList[Math.min(index + 1, triggerList.length - 1)];
        if (next) next.focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        var prev = triggerList[Math.max(index - 1, 0)];
        if (prev) prev.focus();
      } else if (e.key === 'Home') {
        e.preventDefault();
        if (triggerList[0]) triggerList[0].focus();
      } else if (e.key === 'End') {
        e.preventDefault();
        if (triggerList[triggerList.length - 1]) triggerList[triggerList.length - 1].focus();
      }
    });
  }

  function initRoot(root) {
    if (!root || root.dataset.bnCddInit === 'true') return;
    root.dataset.bnCddInit = 'true';
    initFadeUp(root);
    initAccordion(root);
  }

  function initAll() {
    document.querySelectorAll('.bn-cdd').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.bn-cdd');
    if (root) initRoot(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('.bn-cdd');
    if (root) delete root.dataset.bnCddInit;
  });
})();
